module.exports = __webpack_public_path__ + "static/red-berries1-ae37265f88a69f1a69d243e21aff7199.svg";